
/* injects from baggage-loader */

'use strict';

export default class ProjectCommentController {

	constructor($log, User) {
		'ngInject';

		this.$log = $log;
		this.User = User;

		// State of a comment being flagged
		this.flagged = false;

		this.comments = [];
		this.showCommentBox = false;

	}

	$onInit() {
		this.$log.log(this.comment);
	}


	/**
	 * Returns the name of the author
	 */
	getAuthorName(fallback = true) {
		let author = this.comment.get('author');
		if (author) {
			return `${author.get('first_name')} ${author.get('last_name')}`;
		} else {
			return fallback ? '[Deleted User]' : '?';
		}
	}


	/**
	 * Return the title of the author tag if applicable
	 */
	getAuthorTag() {
		return this.comment.get('author_tag');
	}

	/**
	 * Return the text body of the comment
	 */
	getText() {
		return this.comment.get('text');
	}


	/**
	 * Return the timestamp the comment was created at
	 */
	getTimestamp() {
		return this.comment.createdAt;
	}


	/**
	 * Return replies to this comment
	 */
	getReplies() {
		return this.comments.filter(comment => comment.get('parent') ? comment.get('parent').id === this.comment.id : false);
	}


	/**
	 * Returns the comments parent
	 */
	getParent() {
		return this.comment.get('parent');
	}


	/**
	 * Returns the comments project
	 */
	getProject() {
		return this.comment.get('project');
	}


	/**
	 * Reveal the comment box
	 */
	reply() {
		this.showCommentBox = true;
	}


	/**
	 * Reports the comment as containing spam and or inappropriate/irrelevant contnet to the project
	 */
	flagInappropriate() {

		// After comment is flagged once by the current user, don't allow them todo it again
		if (this.flagged === true) {
			return false;
		}

		this.$log.log('Comment flagged')
		this.flagged = true;

		/*
				FLAGGING A COMMENT PROCESS

				1. Someone clicks the comment "flag"
				2. They are prompted to click a "reason" that pops up in the modal
				3. A flag is created in the "Comment_Flags" collection with a ts, reason, and pointer to the comment
				4. A notification is sent to our system admins and possibly the project creator to review the comment
				5. Action can be taken to remove or mediate the comment

				OUR TERMS AND CONDITIONS SHOULD CLEARLY STATE OUR COMMENT ABUSE/SPAM POLICY
				
				"* All comments are subject to review under our Terms & Conditions."

		*/
	}

}



// WEBPACK FOOTER //
// ./src/app/components/projectComment/projectcomment.controller.js